import React from 'react';
import { Skeleton as AntSkeleton } from 'antd';
import styled from 'styled-components';

type SkeletonShape = 'circle' | 'square';

interface SkeletonProps {
  shape?: SkeletonShape;
  width?: CSSSize;
  height?: CSSSize;
  className?: string;
}

const Skeleton = function ({ shape, className, width, height }: SkeletonProps) {
  if (shape === 'circle') {
    return (
      <SkeletonCircle
        className={className}
        active={true}
        shape={shape}
        width={width}
        height={height}
      />
    );
  }
  return (
    <SkeletonSquare
      className={className}
      active={true}
      block={true}
      width={width}
      height={height}
    />
  );
};

const SkeletonSquare = styled(AntSkeleton.Input)<{
  width?: CSSSize;
  height?: CSSSize;
}>`
  &.ant-skeleton.ant-skeleton-element {
    width: ${props => props.width};
    min-width: ${props => props.width};
    height: ${props => props.height};
  }

  &.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
    width: ${props => props.width};
    min-width: ${props => props.width};
    height: ${props => props.height};
  }
`;

const SkeletonCircle = styled(AntSkeleton.Avatar)<{
  width?: CSSSize;
  height?: CSSSize;
}>`
  &.ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {
    width: ${props => props.height};
    min-width: ${props => props.height};
    height: ${props => props.height};
    display: flex;
    justify-content: center;
  }
`;

export { Skeleton };
